const REQUIRED_FORM_FIELD = 'campo obrigatório';

export {
  REQUIRED_FORM_FIELD
}
